function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36",
  height: "36",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  width: "36",
  height: "36",
  rx: "5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 7c5.523 0 10 4.477 10 10s-4.477 10-10 10S8 22.523 8 17 12.477 7 18 7zm0 1.333a8.667 8.667 0 100 17.334 8.667 8.667 0 000-17.334zm.08 6.555c.373 0 .676.303.676.676v6.76a.676.676 0 11-1.352 0v-6.76c0-.373.303-.676.676-.676zm0-4.16a.94.94 0 01.702.295c.19.196.286.427.286.693a.962.962 0 01-.277.71.962.962 0 01-.711.278.962.962 0 01-.71-.277.962.962 0 01-.278-.711c0-.266.095-.497.286-.693a.94.94 0 01.702-.295z",
  fill: "#54585D"
}))));